import React from 'react';

const AdminProfilePageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/profile',
			exact: true,
			component: React.lazy(() => import('./AdminProfilePage')),
		},
	],
};

export default AdminProfilePageConfig;
